import { Route, Routes } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import MainPage from './pages/MainPage/MainPage';
import TechnicalExpertiseDataManagement from './pages/Technical Expertise/TechnicalExpertiseDataManagement';
import TechnicalExpertiseUIDevelopment from './pages/Technical Expertise/TechnicalExpertiseUIDevelopment';
import IndustryNewsPage from './pages/IndustryNewsPage/IndustryNewsPage';
import ContactUsPage from './pages/ContactUs/ContactUsPage';
import { createContext, useState } from 'react';
import PrivacyAndResponsibility from './pages/PrivacyAndResponsibility/PrivacyAndResponsibility';
import { RoutePath } from './constants/common';
import AboutUsPage from './pages/AboutUs/AboutUsPage';

export interface ThemeContextProps {
  theme: string;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps>({
  theme: 'dark',
  toggleTheme: () => {},
});

function App() {
  const [theme, setTheme] = useState<string>(() => {
    const mode = JSON.parse(localStorage.getItem('theme') || '""');

    const validMode = mode !== '' ? mode : 'light';

    if (validMode === 'dark')
      document.documentElement.classList.add('dark-theme');
    else document.documentElement.classList.remove('dark-theme');

    return validMode;
  });

  const toggleTheme = () => {
    setTheme((cur) => {
      const newTheme = cur === 'dark' ? 'light' : 'dark';
      localStorage.setItem('theme', JSON.stringify(newTheme));

      if (newTheme === 'dark')
        document.documentElement.classList.add('dark-theme');
      else document.documentElement.classList.remove('dark-theme');

      return newTheme;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <Header />

      <Routes>
        <Route path={RoutePath.MainPage} Component={MainPage} />
        <Route path={RoutePath.AboutUs} Component={AboutUsPage} />
        <Route
          path={RoutePath.UIDevelopment}
          Component={TechnicalExpertiseUIDevelopment}
        />
        <Route
          path={RoutePath.DataManagement}
          Component={TechnicalExpertiseDataManagement}
        />
        <Route path={RoutePath.IndustryNews} Component={IndustryNewsPage} />
        <Route path={RoutePath.ContactUs} Component={ContactUsPage} />
        <Route
          path={RoutePath.PrivacyAndResponsibility}
          Component={PrivacyAndResponsibility}
        />
      </Routes>

      <Footer />
    </ThemeContext.Provider>
  );
}

export default App;
